export default __webpack_public_path__ + "static/drawer-064ba557e5285f74ea6f17b57b4bef1c.png";